import React, { useEffect, useState } from "react";
import {
  Form, Input, DatePicker, TimePicker, Select, Mentions, Button, message,
  Checkbox, Radio, Modal, Table, InputNumber
 } from 'antd';
import './forms.scss';

const { TextArea } = Input;
const { Option } = Select;

const FormItem = Form.Item;

const EditTourPayTransactionsForm = React.memo(({ loading, resource, itemDetails, user, confirmDialogue,
 tourPayTransactionsTableDataSource, tourPayTransactions, jobElementsByTour, tourPayTransaction,
 payTransactionsByTour, ...props
}) => {
  const { itemType } = itemDetails;
  const { getFieldDecorator, getFieldsError, getFieldsValue } = props.form;
   const [ selectedRowKeysArray, setSelectedRowKeysArray ] = useState([0]);
   const [ dirtyTableRows, setDirtyTableRows ] = useState(false);

  const columns = [
    {
      title: 'Code',
      dataIndex: 'code',
      key: 'code',
    },
    {
      title: 'Pay Transaction',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Assignment',
      dataIndex: 'assignment',
      key: 'assignment',
    },
    {
      title: 'Cost',
      dataIndex: 'cost',
      key: 'cost',
    }
  ];

  const handleSelectedRowChange = async (selectedRowKeys) => {
    setSelectedRowKeysArray(selectedRowKeys);
    await props.getTourPayTransaction(tourPayTransactions.data.find((elem) => elem.id === tourPayTransactionsTableDataSource[selectedRowKeys[0]].id).id);
    console.log(selectedRowKeys); // debug
  }

  const rowSelection = {
    selectedRowKeys: selectedRowKeysArray, // Table component's selectedRowKeys is always an array
    onChange: handleSelectedRowChange,
    type: 'radio',
    onSelect: async (record, selected) => {
      // console.log(selected);
      // console.log(record);
    }
   };

  const invalidForm = () => {
    message.config({
      top: 150,
      duration: 5,
      maxCount: 5,
    });
    message.error('You have one or more invalid form inputs!');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = {};
    // collect all fields currently in error state
    for ( const [field, error] of Object.entries(getFieldsError()) ) {
      if (error) {
        errors[`${field}`] = error;
      }
    }
    if (Object.values(errors).length === 0) {
      console.log('Success! Received values of form: ', getFieldsValue())
      if (tourPayTransaction) {
        props.updateTourPayTransaction();
      } else if (!tourPayTransaction) {
        props.createTourPayTransaction();
      }
    } else {
      invalidForm();
      console.log('Invalid Form! ', errors);
    }
  };

  useEffect(() => {
    itemDetails.itemType = 'tourPayTransaction';
    props.updateState({itemDetails});
  },[]);

  useEffect(() => {
    if (!dirtyTableRows) {
      // set pay transaction initially selected when tab opens
      let selectedTourPayTransaction = tourPayTransactions.data[0];
      itemDetails.selectedTourPayTransactionlDetails = selectedTourPayTransaction;
      props.updateState({itemDetails});
    }
    setDirtyTableRows(true);
  }), [];

  useEffect(() => {
    const form = props.form;
      form.setFieldsValue({
        units: itemDetails.units,
        waived: itemDetails.waived,
        cost: itemDetails.cost,
        remark: itemDetails.remark,
        internalRemark: itemDetails.internalRemark,
        timeKeeperComment: itemDetails.timeKeeperComment
      });
  }, [itemDetails, confirmDialogue, tourPayTransaction, selectedRowKeysArray,
  itemDetails.units, itemDetails.waived, itemDetails.cost, itemDetails.remark,
  itemDetails.internalRemark, itemDetails.timeKeeperComment]);

  // update fields from new pay transaction selection
  useEffect(() => {
    if (itemDetails && tourPayTransaction && tourPayTransaction.data) {
      itemDetails.tourPayTransactionId = tourPayTransaction.data[0].id;
      itemDetails.payTransactionId = tourPayTransaction.data[0].payTransactionId;
      itemDetails.units = tourPayTransaction.data[0].units;
      itemDetails.jobElementId = tourPayTransaction.data[0].jobElementId > 0 ? tourPayTransaction.data[0].jobElementId : null;
      itemDetails.waived = tourPayTransaction.data[0].waived;
      itemDetails.billable = tourPayTransaction.data[0].billable;
      itemDetails.cost = tourPayTransaction.data[0].baseRate;
      itemDetails.remark = tourPayTransaction.data[0].remark;
      itemDetails.internalRemark =  tourPayTransaction.data[0].internalRemark;
      itemDetails.timeKeeperComment = tourPayTransaction.data[0].timeKeeperComment;

      itemDetails.selectedTourPayTransactionlDetails = tourPayTransaction.data[0];

    } else if (itemDetails && !tourPayTransaction) {
      // clear fields for create new pay transaction form
      itemDetails.tourPayTransactionId = null;
      itemDetails.payTransactionId = null;
      itemDetails.units = null;
      itemDetails.jobElementId = null;
      itemDetails.waived = null;
      itemDetails.billable = null;
      itemDetails.cost = null;
      itemDetails.remark = null;
      itemDetails.internalRemark = null;
      itemDetails.timeKeeperComment = null;
    }
    props.updateState({itemDetails});

  },[itemDetails, tourPayTransaction, selectedRowKeysArray])


  const switchToNewPayTransactionForm = async () => {
    tourPayTransaction = null;
    props.updateState({tourPayTransaction});
    setSelectedRowKeysArray(null); // un-select anything in table
  }

  if (itemDetails && !loading
    ) {
    console.log(`selectedRowKeysArray: ${selectedRowKeysArray}`) // debug
    // console.log(`dirtyTableRows: ${dirtyTableRows}`);
    return (

      <Form onSubmit={handleSubmit}>

          <FormItem>
            <Table
              dataSource={tourPayTransactionsTableDataSource}
              columns={columns}
              rowSelection={rowSelection}
              // rowClassName={(record) =>  record.color ? record.color.replace('#', '') : null}
              // onRow={(record) => record.key === selectedRowKeysArray[0] ? record.color = 'greenRow' : null}
              // ßrowClassName={(record) => ''}
            />
          </FormItem>

            <FormItem
                label={<span><span ID="asterisk">* </span><span>Pay Transaction</span></span>}
                style={{ display: "flex", marginBottom: 5 }}
              >
                <Select
                  name="payTransactionId"
                  value={`payTransactionId-${itemDetails.payTransactionId ? itemDetails.payTransactionId.toString() : 0}`}
                  onChange={props.handleOmnibusFieldChange}
                  style={{ width: 300 }}
                >
                  <Option key={null} value={`payTransactionId-${0}`}>&nbsp;</Option>

                  { payTransactionsByTour &&
                    payTransactionsByTour.data.map((elem) => {
                    return <Option key={elem.id} value={`payTransactionId-${elem.id}`}>{elem.name}</Option>
                  })}
                </Select>
              </FormItem>

                <FormItem
                      label="Units"
                      style={{ display: "flex", marginBottom: 5 }}
                >
                  {getFieldDecorator('units', {
                      rules: [{
                        required: true, message: 'Please input units!',
                    }],
                  })(
                    <InputNumber
                      name="units"
                      onChange={(e) => props.handleOmnibusFieldChange(`units-${e}`)}
                      />
                  )}
                </FormItem>

              <FormItem
                label={'Assignment'}
                style={{ display: "flex", marginBottom: 5 }}
              >
                <Select
                  name="jobElementId"
                  value={`jobElementId-${itemDetails.jobElementId ? itemDetails.jobElementId.toString() : 0}`}
                  onChange={props.handleOmnibusFieldChange}
                  style={{ width: 300 }}
                >
                  <Option key={null} value={`jobElementId-${0}`}>&nbsp;</Option>

                  { jobElementsByTour &&
                    jobElementsByTour.data.map((elem) => {
                    return <Option key={elem.id} value={`jobElementId-${elem.id}`}>
                      {`${elem.jobNumber}/${elem.startActual.split('T')[1].slice(0,5)}-${elem.endActual.split('T')[1].slice(0, 5)}/${elem.service}`}
                      </Option>
                  })}
                </Select>
              </FormItem>

              <FormItem
                  label="Waived"
                  style={{ display: "flex", marginBottom: 5 }}
                >
                   {getFieldDecorator('waived', {
                      })(
                        <Checkbox
                          name="waived"
                          disabled
                          checked={itemDetails.waived}
                          onChange={props.handleOmnibusFieldChange}
                        />
                    )}
              </FormItem>

              <FormItem
                  label="Billable"
                  style={{ display: "flex", marginBottom: 5 }}
                >
                   {getFieldDecorator('billable', {
                      })(
                        <Checkbox
                          name="billable"
                          checked={itemDetails.billable}
                          onChange={props.handleOmnibusFieldChange}
                        />
                    )}
              </FormItem>

              <FormItem
                      label="Cost"
                      style={{ display: "flex", marginBottom: 5 }}
                >
                  {getFieldDecorator('cost', {
                      rules: [{
                        required: true, message: 'Please input cost!',
                    }],
                  })(
                    <InputNumber
                      name="cost"
                      onChange={(e) => props.handleOmnibusFieldChange(`cost-${e}`)}
                      readOnly
                      value={tourPayTransaction.data[0].baseRate * itemDetails.units}
                      />
                  )}
                </FormItem>

                <FormItem
                      label="Remark"
                      style={{ display: "flex", marginBottom: 5 }}
                >
                  {getFieldDecorator('remark', {
                  })(
                    <Input
                      name="remark"
                      onChange={props.handleOmnibusFieldChange}
                      maxLength={50}
                      size={'large'}
                      />
                  )}
                </FormItem>

                <FormItem
                      label="Internal Remark"
                      style={{ display: "flex", marginBottom: 5 }}
                >
                  {getFieldDecorator('internalRemark', {
                  })(
                    <Input
                      name="internalRemark"
                      onChange={props.handleOmnibusFieldChange}
                      maxLength={50}
                      size={'large'}
                      />
                  )}
                </FormItem>

                <FormItem
                  label="TK Comment"
                  style={{ display: "flex", marginBottom: 5 }}
                >
                  {getFieldDecorator('timeKeeperComment', {
                  })(
                    <TextArea
                      name="timeKeeperComment"
                      onChange={props.handleOmnibusFieldChange}
                      size={'large'}
                      maxLength={200}
                    />
                  )}
                </FormItem>

              <FormItem
                style={{ marginTop: 20 }}
              >
              { tourPayTransaction &&
                (
                  <React.Fragment>
                    <Button type="primary" ghost size={'large'} htmlType="submit">
                      Update
                    </Button>
                    <Button type="danger" ghost size={'large'} onClick={() => props.handleItemDelete('tourPayTransaction')} >
                      Delete
                    </Button>
                    <Button type="default" size={'large'} onClick={() => switchToNewPayTransactionForm()} >
                      New
                  </Button>
                  </React.Fragment>
                )
              }
              { !tourPayTransaction &&
                  <Button type="default" size={'large'} htmlType="submit">
                    Save
                  </Button>
              }
              </FormItem>

      </Form>
      );
  } else return 'loading...'
})

export default EditTourPayTransactionsForm;

